import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, sortBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getConfigUsagePlatforms,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UsageSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportUsageSummary, sortUsageSummary } from '../../constants';
import { getUsageSummary, getAllUsageSummary, onResetDefaultData } from '../../actions';
import { makeGetListUsageSummary, makeGetListAllUsageSummary } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UsageSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
      ratingType: 'POSTPAID',
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUsageSummary: [],
    sourceOptions: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUsageSummary: props.listUsageSummary,
      totalCount: getPageTotalCount({ ...state, items: props.listUsageSummary }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetUsageSummaryReport },
      onResetDefaultData,
      getConfigUsagePlatforms,
    } = this.props;
    if (modeGetUsageSummaryReport) {
      this.doGetOutputTemplateByType();
      getConfigUsagePlatforms('', ({ success, data }) => {
        if (success && data?.configUsagePlatformList) {
          const sourceOptions = data.configUsagePlatformList.map(val => ({ label: val.name, value: val.name }));
          this.setState({ sourceOptions: sortBy(sourceOptions, ['label']) });
        }
      });
      onResetDefaultData('listUsageSummary');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListUsageSummary();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListUsageSummary());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListUsageSummary());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListUsageSummary();
    });
  };

  doGetListUsageSummary = () => {
    const { filter, page, size, sorted } = this.state;
    const { getUsageSummary } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortUsageSummary[sorted.sortCol] ? sortUsageSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getUsageSummary(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUsageSummary = cb => {
    const { filter, sorted } = this.state;
    const { getAllUsageSummary } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortUsageSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllUsageSummary(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUsageSummary(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUsageSummary, t } = this.props;
        convertJson2Pdf({
          data: listAllUsageSummary,
          t,
          title: t('reportPage:sidebar.usageSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.usageSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUsageSummary(() => {
      const { listAllUsageSummary, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_USAGE_SUMMARY_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.usageSummary')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.usageSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUsageSummary,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUsageSummary,
          t,
          title: t('reportPage:sidebar.usageSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.usageSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.usageSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('USAGE_SUMMARY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportUsageSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUsageSummary,
      emails,
      filter,
      sourceOptions,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUsageSummary,
      t,
      permissions: { modeGetUsageSummaryReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetUsageSummaryReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.usageSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.usageSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UsageSummarySearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  defaultFilter={filter}
                  keyOptionInject="source"
                  optionsInject={sourceOptions}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.usageSummary').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllUsageSummary,
                          t,
                          title: t('reportPage:sidebar.usageSummary').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.usageSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUsageSummary}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listUsageSummary && listUsageSummary.length ? listUsageSummary : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UsageSummary.propTypes = {
  getUsageSummary: PropTypes.func,
  getAllUsageSummary: PropTypes.func,
  listAllUsageSummary: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

UsageSummary.defaultProps = {
  getUsageSummary: () => {},
  getAllUsageSummary: () => {},
  listAllUsageSummary: [],
};

const mapStateToProps = createStructuredSelector({
  listUsageSummary: makeGetListUsageSummary() || [],
  listAllUsageSummary: makeGetListAllUsageSummary() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getUsageSummary,
    getAllUsageSummary,
    uploadMultiPartFiles,
    getConfigUsagePlatforms,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(UsageSummary)
);
